import { Chip, Theme } from '@mui/material';
import { floodCategoryColorsSolid } from 'features/waterLevel/waterLevel.constants';
import { FloodCategory } from 'features/waterLevel/waterLevel.types';
import { useTranslation } from 'react-i18next';

type FloodLevelChipProps = {
  category: FloodCategory | null;
  hasFloodCategories: boolean;
};

const getFloodLevel = (
  category: FloodCategory | null,
  hasFloodCategories: boolean,
): FloodCategory => {
  return category === 'none' && hasFloodCategories
    ? 'normal'
    : (category ?? 'none');
};

export const FloodLevelChip = (props: FloodLevelChipProps): JSX.Element => {
  const { category, hasFloodCategories } = props;
  const { t } = useTranslation();

  const level = getFloodLevel(category, hasFloodCategories);
  const backgroundColor = floodCategoryColorsSolid[level];

  return (
    <Chip
      size="small"
      variant="watchduty-basic"
      label={t(`waterLevel.levels.${level}`)}
      sx={(theme: Theme) => ({
        backgroundColor,
        color: theme.palette.getContrastText(backgroundColor),
      })}
    />
  );
};
